<ng-container *ngIf="!isLoading; else loadingTemplate">
  <ng-container *ngIf="errorMessage">
    <div class="alert alert-danger text-start" role="alert">
      {{ errorMessage }}
    </div>
  </ng-container>
  <div
    class="alert alert-warning position-fixed top-0 start-50 translate-middle-x mt-3 text-center shadow unsaved-changes-alert"
    role="alert"
    *ngIf="viewState === viewStates.EDIT && hasUnsubmittedChanges">
    <div class="fw-bold text-uppercase">Unsaved changes</div>
    <div>You have unsubmitted changes, please Submit to save.</div>
  </div>
  <ng-container *ngIf="form && form.sections">
    <div class="mx-auto">
      <ng-container *ngIf="!hideTitle">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <div class="fw-800" style="font-size: 4rem; color: #430089">
            {{ form.title }}
          </div>
          <ng-container
            *ngIf="
              viewState === viewStates.GRADED &&
              submission?.pass_or_fail !== null &&
              submission?.grade !== null
            ">
            <div
              class="text-center"
              [ngClass]="{
                'text-success': submission?.pass_or_fail === 'pass',
                'text-danger': submission?.pass_or_fail === 'fail'
              }">
              <div class="fs-20">{{ submission?.grade }}</div>
              <div class="fw-bold fs-17">
                {{ submission?.pass_or_fail | titlecase }}
              </div>
            </div>
          </ng-container>
        </div>
        <div
          *ngIf="
            hasRequiredFields &&
            !isSubmissionComplete &&
            viewState !== viewStates.SUBMITTED &&
            viewState !== viewStates.GRADED
          "
          class="text-danger mb-0">
          * Indicates required question
        </div>
        <hr class="border border-tertiary border-1 my-2" />
      </ng-container>
      <div
        *ngIf="
          viewState === viewStates.PREVIEW || viewState === viewStates.EDIT
        "
        class="fs-15 text-muted my-4">
        <div *ngIf="form.anonymity === ProFormAnonymity.REQUIRED">
          This form is anonymous. Your identity will not be recorded.
        </div>
        <div *ngIf="form.anonymity === ProFormAnonymity.NONE">
          This form is not anonymous. Your responses will be linked to your user
          account.
        </div>
      </div>
      <div class="mt-3" *ngIf="!isSubmissionComplete">
        <ng-container
          *ngIf="
            viewState !== viewStates.SUBMITTED &&
              viewState !== viewStates.GRADED;
            else submittedView
          ">
          <!-- All sections visible; conditional sections shown/hidden based on answers -->
          <ng-container
            *ngFor="
              let section of form.sections | sort : 'sort_order';
              let i = index
            ">
            <ng-container *ngIf="isSectionVisible(section)">
              <!-- Section header (only when 2+ sections) -->
              <ng-container *ngIf="form.sections.length > 1">
                <div
                  class="proform-section-header"
                  [ngClass]="{
                    'proform-section-header--no-desc': !section.description,
                    'proform-section-header--gap': i > 0
                  }">
                  <span class="proform-section-title">
                    {{ section.title || "Untitled Section" }}
                  </span>
                </div>
                <div
                  *ngIf="section.description"
                  class="proform-section-description">
                  {{ section.description }}
                </div>
              </ng-container>

              <ng-container
                *ngFor="
                  let question of section.questions | sort : 'sort_order'
                ">
                <div class="proform-question-item">
                  <app-proforms-question
                    [showMissed]="form.show_missed"
                    [showAnswers]="form.show_answers"
                    [submitted]="submitted"
                    [question]="question"
                    [isObservationSession]="isObservationSession"
                    [formId]="formId"
                    [viewState]="viewState"></app-proforms-question>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>

        <ng-template #submittedView>
          <ng-container
            *ngFor="
              let section of form.sections | sort : 'sort_order';
              let i = index
            ">
            <ng-container *ngIf="isSectionVisible(section)">
              <ng-container *ngIf="form.sections.length > 1">
                <div
                  class="proform-section-header"
                  [ngClass]="{
                    'proform-section-header--no-desc': !section.description,
                    'proform-section-header--gap': i > 0
                  }">
                  <span class="proform-section-title">
                    {{ section.title || "Untitled Section" }}
                  </span>
                </div>
                <div
                  *ngIf="section.description"
                  class="proform-section-description">
                  {{ section.description }}
                </div>
              </ng-container>
              <ng-container
                *ngFor="
                  let question of section.questions | sort : 'sort_order'
                ">
                <div class="proform-question-item">
                  <app-proforms-question
                    [showMissed]="form.show_missed"
                    [showAnswers]="form.show_answers"
                    [submitted]="submitted"
                    [question]="question"
                    [isObservationSession]="isObservationSession"
                    [formId]="formId"
                    [viewState]="viewState"></app-proforms-question>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-template>
      </div>

      <!-- Outro screen (shown after successful submission) -->
      <ng-container *ngIf="isSubmissionComplete">
        <div class="mb-5">
          <app-safehtml [html]="form.outro"></app-safehtml>
        </div>
        <ng-container *ngIf="submission">
          <div class="row justify-content-center mb-5">
            <div
              class="col-12 col-sm-6 col-lg-6 col-xxl-6 align-self-center"
              *ngIf="submission.pass_or_fail">
              <app-quick-stat
                [label]="'Result'"
                [stat]="submission.pass_or_fail | titlecase"
                [statStyle]="
                  submission.pass_or_fail === 'pass' ? 'success' : 'danger'
                " />
            </div>
            <div
              class="col-12 col-sm-6 col-lg-6 col-xxl-6 align-self-center"
              *ngIf="submission.grade != null">
              <app-quick-stat
                [label]="'Grade'"
                [stat]="submission.grade"
                [statStyle]="
                  submission.pass_or_fail === 'pass' ? 'success' : 'danger'
                " />
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>

    <div class="d-flex align-items-center">
      <ng-container
        *ngIf="isSubmissionComplete && submission && form.show_missed">
        <button
          class="btn btn-md btn-primary ms-auto"
          (click)="onGradedViewRequested()">
          View Graded Quiz
        </button>
      </ng-container>

      <div class="button-wrapper w-100">
        <ng-container
          *ngIf="form.type === ProFormType.OBSERVATION; else default">
          <div
            *ngIf="viewState === viewStates.EDIT && !isSubmissionComplete"
            class="obsv-form d-flex justify-content-between align-items-center flex-column flex-md-row">
            <div class="d-flex me-2 align-items-center">
              <i class="bi bi-exclamation-circle fs-22 me-3 ms-3"></i>
              <div class="fs-12 obsv-message">
                A draft is auto-saved on your current device. The submit button
                will make your observation feedback viewable to the participant.
              </div>
            </div>
            <button
              [disabled]="submitLoading"
              (click)="submitForm()"
              class="btn btn-md btn-primary btn-submit px-5">
              <ng-container *ngIf="submitLoading">
                <div class="spinner-border spinner-border-sm" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </ng-container>
              Submit
            </button>
          </div>
        </ng-container>
        <ng-template #default>
          <div class="d-flex justify-content-end">
            <button
              *ngIf="viewState === viewStates.EDIT && !isSubmissionComplete"
              [disabled]="submitLoading"
              (click)="submitForm()"
              class="btn btn-md btn-primary ms-auto">
              <ng-container *ngIf="submitLoading">
                <div class="spinner-border spinner-border-sm" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </ng-container>
              Submit
            </button>
          </div>
        </ng-template>
      </div>
    </div>
  </ng-container>
</ng-container>
<ng-template #loadingTemplate>
  <div
    class="w-100 position-relative"
    style="background-color: #fff; height: 500px">
    <app-loader></app-loader>
  </div>
</ng-template>
